// extracted by mini-css-extract-plugin
module.exports = {"prizes":"styles_prizes__1Ot9I","backgroundImage":"styles_backgroundImage__3HC8n","prizeList":"styles_prizeList__11p_J","prize":"styles_prize__1qu7N"};